export enum DepartmentListSort {
  Label = 1,
  CreationDate = 2,
  LastUpdateUser = 3,
}
